export function collectSliderImagesFromDom() {
    var containers = document.querySelectorAll('[data-block-id^="image-slider-"][data-prop-gallery]');
    var images = [];
    var seen = new Set();
    containers.forEach(function (container) {
        var raw = container.getAttribute('data-prop-gallery');
        if (!raw)
            return;
        var gallery = [];
        try {
            gallery = JSON.parse(raw);
        }
        catch (_a) {
            return;
        }
        if (!Array.isArray(gallery))
            return;
        gallery.forEach(function (image) {
            var _a, _b;
            var url = (_a = image.url) !== null && _a !== void 0 ? _a : '';
            if (!url)
                return;
            var id = typeof image.id === 'number' ? image.id : 0;
            var key = id > 0 ? "id:".concat(id) : "url:".concat(url);
            if (seen.has(key))
                return;
            seen.add(key);
            images.push({
                id: id,
                url: url,
                alt: (_b = image.alt) !== null && _b !== void 0 ? _b : '',
            });
        });
    });
    return images;
}
